import React from 'react';
import PopoverContainer from 'components/pure/utils/PopoverContainer';
import {Link} from 'react-router';
import buildUrl from 'components/dashboard/buildUrl';

export default class PlanProgress extends React.PureComponent {
  registerPopoverItem(anchorEl, content) {
    if (this.popoverContainer) {
      this.popoverContainer.registerPopoverItem(anchorEl, content);
    }
  }

  render() {
    const {repId, planId, coachId, managerId, adminId} = this.props;
    // NOTE: this link does not need to push to DashboardHistoryStore
    // because the subsequent plan will still show under the manager (or coach)'s dash, not the rep's

    return (
      <span
        className="plan-completion-container"
        ref={c => this.registerPopoverItem(c, () => this.props.makePlanPopoverContent())}>
        <PopoverContainer
          anchorOriginVertical="top"
          targetOriginVertical="bottom"
          containerClassName="plan-link"
          hideEmpty={true}
          ref={r => (this.popoverContainer = r)}
        />{' '}
        <Link
          to={{
            pathname: buildUrl({coachId, managerId, adminId}) + '/coaching-plans',
            query: {planId, repId},
            state: this.props.linkState || {},
          }}
          className="plan-link">
          {this.props.renderPlanProgress()}
        </Link>
      </span>
    );
  }
}
